export {
  FooterImageLinks,
  type FooterImageLinksProps,
} from './FooterImageLinks';
export { footerImageLinksSchema } from './schema';
